import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { BarChart3, ChevronDown, LogOut, UserRound } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { logout } from '../../services/authService';
import { getUserIdentityFromToken } from '../../utils/authUtils';

export default function UserAvatar() {
  const navigate = useNavigate();
  const [userIdentity, setUserIdentity] = useState(() => getUserIdentityFromToken());

  const refreshUserIdentity = () => {
    setUserIdentity(getUserIdentityFromToken());
  };

  const handleLogout = async () => {
    // call logout service
    await logout();
    navigate('/login');
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <MenuButton
        onClick={refreshUserIdentity}
        onKeyDown={refreshUserIdentity}
        className="flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full hover:bg-white/20 transition"
      >
        <UserRound size={12} />
        <p className="text-sm">Account</p>
        <ChevronDown size={16} />
      </MenuButton>

      <MenuItems className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-white/10 rounded-md bg-white/10 backdrop-blur p-2 shadow-lg focus:outline-none z-50">
        <div className="px-2 py-2 text-sm text-white">
          <p className="font-medium break-words">{userIdentity?.displayName || 'Account'}</p>
          <p className="mt-0.5 text-xs text-white/70">Signed in</p>
        </div>

        <div className="pt-1">
          <MenuItem>
            {({ active }) => (
              <button
                type="button"
                onClick={() => navigate('/usage')}
                className={`${
                  active ? 'bg-white/20 text-white' : 'text-white/80'
                } group flex w-full items-center rounded-md px-2 py-2 text-sm transition`}
              >
                <BarChart3 size={16} className="mr-2" />
                Usage
              </button>
            )}
          </MenuItem>

          <MenuItem>
            {({ active }) => (
              <button
                type="button"
                onClick={handleLogout}
                className={`${
                  active ? 'bg-white/20 text-white' : 'text-white/80'
                } group flex w-full items-center rounded-md px-2 py-2 text-sm transition`}
              >
                <LogOut size={16} className="mr-2" />
                Logout
              </button>
            )}
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
}
